import { Link } from 'react-router-dom';

export default function ServicesPage() {
  return (
    <div
      className="min-h-screen flex flex-col relative overflow-hidden"
      style={{ background: 'linear-gradient(160deg, #1a1a1a 0%, #2a2a2a 50%, #1a1a1a 100%)' }}
      dir="rtl"
    >
      {/* Background decorative */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute top-[-120px] left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full opacity-10"
          style={{ background: 'radial-gradient(circle, #F5A623 0%, transparent 70%)' }}
        />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              'linear-gradient(#F5A623 1px, transparent 1px), linear-gradient(90deg, #F5A623 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      {/* Header */}
      <header
        className="sticky top-0 z-50"
        style={{
          background: 'rgba(26,26,26,0.95)',
          borderBottom: '1px solid rgba(245,166,35,0.2)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/645339dfad8e1015d6f60a0aacde7112/7ac018fe95b5893e2914eabc8075ecee.png"
              alt="Logo"
              className="h-12 w-12 object-contain"
            />
            <span className="font-bold text-white text-sm hidden sm:block">للتأسيسات والسيطرة الكهربائية QC</span>
          </Link>
          <nav className="flex items-center gap-2">
            <Link
              to="/"
              className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-gray-300 hover:text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line"></i>
              <span>الرئيسية</span>
            </Link>
            <span
              className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-white whitespace-nowrap"
              style={{ background: '#F5A623', boxShadow: '0 2px 12px rgba(245,166,35,0.4)' }}
            >
              <i className="ri-tools-line"></i>
              <span>خدماتنا</span>
            </span>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/hero.jpg" alt="hero" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        </div>
        <div className="relative z-10 w-full px-4 py-20 text-center text-white">
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">خدماتنا الهندسية</h1>
          <p className="text-base sm:text-lg text-white/85 max-w-2xl mx-auto">
            نقدم مجموعة متكاملة من الخدمات الهندسية الكهربائية والصناعية بكادر متخصص وأعلى معايير الجودة
          </p>
        </div>
      </section>

      {/* About Us Section */}
      <section className="relative z-10 py-14 px-4">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-10">
          <div className="flex-1 text-right">
            <h2 className="text-2xl font-bold text-white mb-4">من نحن</h2>
            <p className="text-gray-300 text-base leading-8">
              نعمل في مجال السيطرة والتحكم الصناعي <strong className="text-[#F5A623]">(HMI & PLC)</strong> وجميع لوحات
              السيطرة <strong className="text-[#F5A623]">(Classic control & ATS)</strong> ومنظومات الهيدروليك ومنظومات
              الهواء ومضخات المياه، بكادر هندسي متخصص. مستعدون لنصب وتجهيز كافة المعامل والشركات بجميع لوحات السيطرة
              والتحكم الصناعي. كما نحن مستعدون لاستيراد جميع{' '}
              <strong className="text-[#F5A623]">الحساسات والمتحكمات والقطع الكهربائية</strong> لجميع الشركات وخطوط
              الإنتاج.
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              {[
                { icon: 'ri-cpu-line', label: 'HMI & PLC' },
                { icon: 'ri-settings-3-line', label: 'Classic control & ATS' },
                { icon: 'ri-drop-line', label: 'منظومات الهيدروليك' },
                { icon: 'ri-wind-line', label: 'منظومات الهواء' },
                { icon: 'ri-water-flash-line', label: 'مضخات المياه' },
                { icon: 'ri-building-2-line', label: 'تجهيز المعامل والشركات' },
                { icon: 'ri-global-line', label: 'استيراد حساسات ومتحكمات' },
                { icon: 'ri-plug-line', label: 'قطع كهربائية لخطوط الإنتاج' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2 justify-end">
                  <span className="text-sm text-gray-300 font-medium">{item.label}</span>
                  <div
                    className="w-8 h-8 flex items-center justify-center rounded-full"
                    style={{ background: 'rgba(245,166,35,0.15)' }}
                  >
                    <i className={`${item.icon} text-[#F5A623]`}></i>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div
            className="w-full md:w-80 h-64 rounded-2xl overflow-hidden shadow-lg flex-shrink-0"
            style={{ border: '1px solid rgba(245,166,35,0.2)' }}
          >
            <img src="/about.jpg" alt="معلومات عنا" className="w-full h-full object-cover object-top" />
          </div>
        </div>
      </section>

      {/* Clamp Meter Section */}
      <section className="relative z-10 py-14 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-white mb-2">أجهزة وأدواتنا</h2>
            <div className="flex items-center justify-center gap-2 mt-2">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-[#F5A623]" />
              <span className="text-xs text-[#F5A623] tracking-widest uppercase">معدات احترافية</span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-[#F5A623]" />
            </div>
          </div>

          <div
            className="relative flex flex-col md:flex-row items-center gap-10 rounded-2xl p-8"
            style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0.03) 100%)',
              border: '1px solid rgba(245,166,35,0.2)',
              boxShadow: '0 4px 32px rgba(0,0,0,0.4)',
              backdropFilter: 'blur(10px)',
            }}
          >
            {/* الوكيل الرئيسي بالعراق + تحميل PDF */}
            <div className="static md:absolute md:top-4 md:left-4 z-20 flex items-center gap-3 mb-4 md:mb-0">
              <div
                className="px-6 py-2 rounded-2xl font-extrabold text-[#F5A623] border-2 border-[#F5A623]"
                style={{ background: 'rgba(0,0,0,0.35)', backdropFilter: 'blur(6px)' }}
              >
                الوكيل الرئيسي بالعراق
              </div>

              <a
                href="/specs.pdf"
                download
                className="px-6 py-2 rounded-2xl font-extrabold text-[#F5A623] border-2 border-[#F5A623] inline-flex items-center gap-2"
                style={{ background: 'rgba(0,0,0,0.35)', backdropFilter: 'blur(6px)' }}
              >
                <i className="ri-file-pdf-2-line"></i>
                <span>تحميل مواصفات الجهاز</span>
              </a>
            </div>

            {/* Image */}
            <div className="w-full md:w-72 flex flex-col gap-3 flex-shrink-0">
              <div
                className="w-full h-80 rounded-2xl overflow-hidden flex items-center justify-center"
                style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(245,166,35,0.15)' }}
              >
                <img
                  src="https://static.readdy.ai/image/645339dfad8e1015d6f60a0aacde7112/b87eae58a67062435d9f81ea2b24ee67.jpeg"
                  alt="Clamp Meter"
                  className="w-full h-full object-contain p-4"
                />
              </div>

              {/* WhatsApp Buy Button */}
              <a
                href="https://wa.me/9647779577796?text=%D8%A3%D8%B1%D9%8A%D8%AF%20%D8%B4%D8%B1%D8%A7%D8%A1%20%D8%AC%D9%87%D8%A7%D8%B2%20%D8%A7%D9%84%D9%83%D9%84%D8%A7%D9%85%D8%A8%20%D9%85%D9%8A%D8%AA%D8%B1%20%D8%A7%D9%84%D8%B0%D9%83%D9%8A"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center gap-2 py-3 rounded-xl text-white font-bold text-sm transition-all cursor-pointer whitespace-nowrap hover:scale-[1.02] active:scale-[0.98]"
                style={{
                  background: 'linear-gradient(135deg, #25D366, #1ebe5d)',
                  boxShadow: '0 4px 20px rgba(37,211,102,0.4)',
                }}
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span>اطلب عبر واتساب</span>
              </a>
            </div>

            {/* Info */}
            <div className="flex-1 text-right">
              <div
                className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium mb-4"
                style={{
                  background: 'rgba(245,166,35,0.15)',
                  color: '#F5A623',
                  border: '1px solid rgba(245,166,35,0.3)',
                }}
              >
                <i className="ri-flashlight-line"></i>
                <span>جهاز قياس احترافي</span>
              </div>

              <h3 className="text-xl font-bold text-white mb-3">كلامب ميتر ذكي — Smart AC Clamp Meter</h3>

              <p className="text-gray-300 text-sm leading-7 mb-5">
                جهاز كلامب ميتر ذكي أوتو من الفئة الاحترافية، يتميز بشاشة ملونة عالية الدقة وقراءة TRUE RMS بدقة 6000 عدّ.
                مناسب لقياس التيار المتردد، الجهد، المقاومة، السعة، والتردد. مزود بخاصية NCV للكشف عن الجهد بدون تلامس.
              </p>

              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: 'ri-bar-chart-line', label: 'TRUE RMS — 6000 Counts' },
                  { icon: 'ri-palette-line', label: 'شاشة ملونة عالية الدقة' },
                  { icon: 'ri-wifi-off-line', label: 'كشف NCV بدون تلامس' },
                  { icon: 'ri-flashlight-line', label: 'قياس AC/DC متعدد' },
                  { icon: 'ri-temp-hot-line', label: 'قياس درجة الحرارة' },
                  { icon: 'ri-shield-check-line', label: 'CAT III — 600V آمن' },
                ].map((feat) => (
                  <div key={feat.label} className="flex items-center gap-2 justify-end">
                    <span className="text-xs text-gray-300">{feat.label}</span>
                    <div
                      className="w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0"
                      style={{ background: 'rgba(245,166,35,0.15)' }}
                    >
                      <i className={`${feat.icon} text-[#F5A623] text-sm`}></i>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative z-10 py-5 text-center mt-4" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <p className="text-xs text-gray-500">
          تم البرمجة من قبل <span className="font-bold text-[#F5A623]">Murthdha abdulzahra</span>
        </p>
      </footer>
    </div>
  );
}